module.exports = __webpack_public_path__ + "static/media/icon-baculo.ae8958a3.svg";